import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  change() {
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("contact_id", this.element.value)
    const sender = this.element.form?.elements.namedItem("document_delivery_form[sender_identity_id]")
    if (sender?.value) url.searchParams.set("sender_identity_id", sender.value)
    const frame = this.element.closest("turbo-frame")

    if (frame) {
      frame.src = url.toString()
    } else {
      window.location.assign(url)
    }
  }
}
